import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { InvoiceProvider } from './context/InvoiceContext';
import { AuthProvider } from './context/AuthContext';

import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './pages/LoginPage';

import InvoiceForm from './components/InvoiceForm';
import TravelInvoiceForm from './components/TravelInvoiceForm';
import MarketingInvoiceForm from './components/MarketingInvoiceForm';
import ExcursionBookingForm from './components/ExcursionBookingForm';
import InvoiceList from './components/InvoiceList';
import Settings from './components/Settings';
import InvoicePreview from './components/InvoicePreview';
import PublicInvoicePage from './components/PublicInvoicePage';
import InvoiceEdit from './components/InvoiceEdit';
import TravelInvoiceEdit from './components/TravelInvoiceEdit';
import MarketingInvoiceEdit from './components/MarketingInvoiceEdit';
import ExcursionBookingEdit from './components/ExcursionBookingEdit';
import CustomerManagement from './components/CustomerManagement';
import ProductManagement from './components/ProductManagement';
import PaymentSuccess from './components/PaymentSuccess';
import PaymentCancel from './components/PaymentCancel';

import './App.css';

function App() {
  return (
    <InvoiceProvider>
      <AuthProvider>
        <Router>
          <Routes>
            {/* Public Routes */}
            <Route path="/public/invoice/:id" element={<PublicInvoicePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />

            {/* Protected Admin Routes */}
            <Route 
              path="/*" 
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<InvoiceForm />} />
              <Route path="marketing" element={<MarketingInvoiceForm />} />
              <Route path="travel" element={<TravelInvoiceForm />} />
              <Route path="excursion" element={<ExcursionBookingForm />} />
              <Route path="invoices" element={<InvoiceList />} />
              <Route path="customers" element={<CustomerManagement />} />
              <Route path="products" element={<ProductManagement />} />
              <Route path="settings" element={<Settings />} />
              <Route path="preview/:id" element={<InvoicePreview />} />
              <Route path="edit/:id" element={<InvoiceEdit />} />
              <Route path="marketing-edit/:id" element={<MarketingInvoiceEdit />} />
              <Route path="travel-edit/:id" element={<TravelInvoiceEdit />} />
              <Route path="excursion-edit/:id" element={<ExcursionBookingEdit />} />
            </Route>
          </Routes>
        </Router>
      </AuthProvider>
    </InvoiceProvider>
  );
}

export default App;